
export const Footer = () => {
  return (
    <>


<footer className="bg-black text-white rounded-lg shadow-sm dark:bg-gray-900 m-4">
    <div className="w-full max-w-screen-xl mx-auto p-4 md:py-8">
        <div className="sm:flex sm:items-center sm:justify-between">
          <p className="mx-auto">FlowRun</p>
        </div>
        <hr className="my-6 border-gray-200 sm:mx-auto dark:border-gray-700 lg:my-8" />
        <span className="block text-sm text-gray-100 sm:text-center dark:text-gray-400">© 2023 <a href="/" className="hover:underline">FlowRun™</a>. All Rights Reserved.</span>
    </div>
</footer>


    </>
  )
}
